import { cliente } from '@/lib/cliente';
import { useQuery } from '@tanstack/react-query';

export function useCuentasBancoBC() {
  return useQuery({
    queryKey: ['bc-bank-accounts'],
    queryFn: () => cliente.bcBankAccounts.listar(),
    staleTime: 5 * 60 * 1000,
  });
}
